import React from 'react';
import PropsType from 'prop-types';

function LoadingEffect(props) {
  const { height, width } = props;
  return (
    <div className={`animated-background ${height} ${width}`}>
      <div className="background-masker" />
    </div>
  );
}

LoadingEffect.propTypes = {
  height: PropsType.string.isRequired,
  width: PropsType.string.isRequired
};

export default LoadingEffect;
